import React from "react";
import cn from "classnames";
import { Text } from "../Typography";
import defaultClassName from "../../scss/defaultClassName";
import "./Form.scss";
/**
 * Form component.
 * @param children - The contents of the form.
 * @returns Form
 */
const Form = React.forwardRef(({ children, width = "full", ...rest }, ref) => {
    const className = cn(defaultClassName, "form", `width-${width}`);
    return (React.createElement("div", { className: className },
        React.createElement("form", { ref: ref, ...rest }, children)));
});
/**
 * FormRow component.
 * @param children - The contents of the form.
 * @param margin - The bottom margin of the form row, 8px 16px or 24px.
 * @param verticalAlign - The position of the form row items.
 * @param horizontalAlign - The position of the form row content.
 * @param errorText - The error text to display. Make sure you use a margin of "lg" or greater if you plan to set this.
 * @returns FormRow
 */
export const FormRow = ({ children, margin = "lg", error = undefined, verticalAlign = "center", horizontalAlign = "left", theme = "primary", extendBackground = false, ...props }) => {
    const className = cn(defaultClassName, "form-row", { extendBackground }, `vertical-align-${verticalAlign}`, `horizontal-align-${horizontalAlign}`, theme);
    const errorTextClassName = cn(defaultClassName, "error-placeholder", `height-${margin}`);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: className, ...props }, children),
        React.createElement("div", { className: errorTextClassName }, error && (React.createElement("div", { className: "text-wrapper" },
            React.createElement(Text, { size: "md", theme: "danger" }, error))))));
};
export default Form;
//# sourceMappingURL=Form.js.map